export function getPendo() {
  if (import.meta.server)
    return null

  return (window as any)?.pendo
}
